import customPageApi from '../../../../api/customPage';

/**
 * 缓存信息
 * */
export default {
  namespaced: true,
  state: {
    // 自定义页面
    pages: {}
  },
  getters: {
    get: state => id => {
      return state.pages[id];
    }
  },
  actions: {
    /**
     * @description 加载数据视图
     * @param {Object} state vuex state
     * @param {*} id 代码
     */
    async load({ state }, id) {
      if (!(id in state.pages)) {
        let res = await customPageApi.get(id);
        state.pages[id] = res;

        return res;
      } else {
        return state.pages[id];
      }
    }
  }
};
